import { fetchSameOrigin } from '../Utils';
function unlockAccount (memberId) {
  return fetchSameOrigin(`/members/${memberId}/reset_two_factor_pin_attempts_count`, 'PUT')
  .then(resp => resp.json().then(data => new Promise((resolve) => {
    window.location.reload()
    resolve();
  })));
}
export default unlockAccount;
